<template>
  <div class="edt">
    <v-app-bar
      flat
      color="transparent"
      class="main-appbar"
    >
      <app-bar-nav-icon />
      <div class="d-flex align-center">
        <v-toolbar-title>
          <h1 class="headline font-weight-bold">{{ pageTitle }}
          </h1>
        </v-toolbar-title>
      </div>
      <v-spacer />
      <div>
        <v-btn
          color="primary"
          class="mr-4"
          medium
          @click="onCancel"
          :disabled="form.$busy"
          text
          style="text-transform: none;"
        >Cancel</v-btn>
        <v-btn
          color="primary"
          medium
          @click="onSave"
          :loading="form.$busy"
          style="text-transform: none;"
        >Save</v-btn>
      </div>
    </v-app-bar>
    <v-tabs
      v-model="tab"
      background-color="transparent"
      grow
    >
      <v-tab
        v-for="item in tabItems"
        :key="item"
      >
        {{ item }}
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item key="Page Details">
        <v-row class="px-4 py-4">
          <v-col
            lg="8"
            md="6"
            sm="12"
            xs="12"
          >
            <v-card
              outlined
              class="px-6 mt-4"
            >
              <label class="subtitle-1 d-block pb-3 pt-2 mt-4 grey--text">Page Info</label>
              <v-text-field
                v-model="form.title_tag"
                outlined
                label="Page Title"
                :error-messages="form.$getError('title_tag')"
              />
            </v-card>

            <v-card
              outlined
              class="px-6 mt-6"
            >
              <label class="subtitle-1 d-block pb-3 pt-2 mt-4 grey--text">Main Page Settings</label>

              <image-file-input-viewer
                label="Hero Image"
                v-model="form.hero_banner"
                :clearable="true"
                :error-messages="form.$getError('hero_banner')"
              />

              <image-file-input-viewer
                label="Mobile Hero Image"
                v-model="form.hero_banner_mobile"
                :clearable="true"
                :error-messages="form.$getError('hero_banner_mobile')"
              />

              <v-text-field
                v-model="form.hero_banner_url"
                outlined
                label="Banner URL"
                :error-messages="form.$getError('hero_banner_url')"
              />

              <v-checkbox
                label="Hide Hero Image"
                v-show="form.hero_banner || form.hero_banner_mobile"
                v-model="form.hide_banner"
              />

              <v-text-field
                v-model="form.desktop_width"
                outlined
                label="Desktop Width (px)"
                :error-messages="form.$getError('desktop_width')"
                type="number"
              />

              <v-textarea
                outlined
                label="T&Cs Text"
                rows="4"
                v-model="form.tnc_txt"
                :error-messages="form.$getError('tnc_txt')"
              />

              <v-text-field
                v-model="form.tnc_btn_txt"
                outlined
                label="T&Cs Button Text"
                :error-messages="form.$getError('tnc_btn_txt')"
              />

              <v-select
                v-model="form.tnc_txt_weight"
                outlined
                label="T&Cs Button Text Weight"
                :error-messages="form.$getError('tnc_txt_weight')"
                :items="txtWeightOptions"
              />

              <v-text-field
                v-model="form.tnc_btn_url"
                outlined
                label="T&Cs Button Link"
                :error-messages="form.$getError('tnc_btn_url')"
              />

              <color-picker
                label="Button Color"
                v-bind:color.sync="form.main_btn_color"
              />

              <color-picker
                label="Button Text Color"
                v-bind:color.sync="form.tnc_txt_color"
              />

              <label class="subtitle-1 pb-3 pt-1 mt-4">Button size</label>
              <v-radio-group
                v-model="form.tnc_btn_size"
                row
              >
                <v-radio
                  label="Blocked"
                  value="blocked"
                ></v-radio>
                <v-radio
                  label="XS"
                  value="extra_small"
                ></v-radio>
                <v-radio
                  label="S"
                  value="small"
                ></v-radio>
                <v-radio
                  label="M"
                  value="medium"
                ></v-radio>
                <v-radio
                  label="L"
                  value="large"
                ></v-radio>
                <v-radio
                  label="XL"
                  value="extra_large"
                ></v-radio>
              </v-radio-group>

            </v-card>

            <!-- <v-card
              outlined
              class="px-6 py-8 mt-6"
            >
              <v-card-title>Default Properties</v-card-title>

              <color-picker
                label="Default Button Color"
                v-bind:color.sync="form.main_btn_color"
              />

              <font-selector
                v-bind:selectedFont.sync="form.main_font"
                InputLabel="Default Main Font"
              />

              <font-selector
                v-bind:selectedFont.sync="form.sub_font"
                InputLabel="Default Sub Font"
              />

            </v-card> -->
          </v-col>
          <v-col
            lg="4"
            md="6"
            sm="12"
            class="mt-4"
          >
            <slug-generator
              ref="slugGenerator"
              :base-string="form.title_tag"
              component-label="Page Path"
              :isPath="true"
              v-model="slug"
              :error-messages="form.$getError('path_url')"
            />

            <publish-status
              class="mt-6"
              v-bind:publishStatus.sync="form.publish_status"
            />
            <v-card
              outlined
              class="px-6 pt-6 pb-3 mt-4"
            >
              <!-- <v-checkbox
                label="Is Duplicate"
                v-model="form.is_duplicate"
              /> -->
              <v-checkbox
                label="No Index"
                v-model="form.is_noindex"
              />
              <v-checkbox
                label="Hide Promotion"
                v-model="form.hide_promotion"
              />
              <v-checkbox
                label="Hide Bonus"
                v-model="form.hide_bonus"
              />

            </v-card>

            <published-date-selector
              v-show="showPublishDateSelector"
              pageTitle="Publish Date"
              class="mt-6"
              v-model="form.published_at"
              :errorMessages="form.$getError('published_at')"
            />

            <social-sharing-meta-tag
              v-bind:title.sync="form.seo_title"
              v-bind:description.sync="form.seo_description"
              v-bind:image.sync="form.seo_thumbnail"
              class="mt-6"
            />

            <image-alt-text v-bind:imageAltText.sync="form.image_alt_text" />
          </v-col>
        </v-row>
      </v-tab-item>
      <v-tab-item key="Page Sections">
        <v-row class="px-4 py-4">
          <v-col
            lg="8"
            md="6"
            sm="12"
            xs="12"
          >
            <draggable
              v-model="form.page_sections"
              group="people"
              @start="drag=true"
              @end="drag=false"
              class="list-group page-content-draggable-container"
            >
              <v-expansion-panels
                class="mt-4 pb-6"
                :class="{'mt-6' : marginTop(i)}"
                v-for="(page, i) in form.page_sections"
                :key="i"
              >
                <v-expansion-panel :class="{ 'section-has-error' : checkSectionError(i)}">
                  <v-expansion-panel-header> {{ getSectionName(page.type) }} <v-spacer></v-spacer> # {{ i + 1 }} </v-expansion-panel-header>

                  <v-expansion-panel-content class="pb-4">
                    <v-card
                      outlined
                      class="pb-4"
                    >
                      <v-toolbar flat>
                        <v-spacer></v-spacer>

                        <v-btn
                          @click="removeSection(i)"
                          color="red"
                          class="mr-3"
                          small
                          icon
                        >
                          <v-icon
                            small
                            color="red"
                          >mdi-trash-can-outline</v-icon>
                        </v-btn>
                      </v-toolbar>

                      <how-to
                        v-if="page.type === 'page_how_to'"
                        :inputName='getSectionName(page.type)'
                        v-bind:sectionData.sync="form.page_sections[i]"
                        :errorMessages="form.$errors"
                        :currIndex="i"
                        v-bind:removedSections.sync="form.removed_sections"
                      />

                      <feature
                        v-if="page.type === 'page_feature'"
                        :inputName='getSectionName(page.type)'
                        v-bind:sectionData.sync="form.page_sections[i]"
                        :errorMessages="form.$errors"
                        :currIndex="i"
                        v-bind:removedSections.sync="form.removed_sections"
                      />

                      <page-button
                        v-if="page.type === 'page_button'"
                        :inputName='getSectionName(page.type)'
                        v-bind:sectionData.sync="form.page_sections[i]"
                        :errorMessages="form.$errors"
                        :currIndex="i"
                      />

                      <page-body
                        v-if="page.type === 'page_body'"
                        :inputName='getSectionName(page.type)'
                        v-bind:sectionData.sync="form.page_sections[i]"
                      />

                      <page-heading
                        v-if="page.type === 'page_heading'"
                        :inputName='getSectionName(page.type)'
                        v-bind:sectionData.sync="form.page_sections[i]"
                        :errorMessages="titleError(head(form.$getError('page_sections.'+ i + '.' + page.type + '.title' )))"
                      />

                      <page-cards
                        v-if="page.type === 'page_card'"
                        :inputName='getSectionName(page.type)'
                        v-bind:sectionData.sync="form.page_sections[i]"
                        :errorMessages="form.$errors"
                        :currIndex="i"
                        v-bind:removedSections.sync="form.removed_sections"
                      />

                      <page-gallery
                        v-if="page.type === 'page_gallery'"
                        :inputName='getSectionName(page.type)'
                        v-bind:sectionData.sync="form.page_sections[i]"
                        v-bind:removedSections.sync="form.removed_sections"
                      />

                      <page-service
                        v-if="page.type === 'page_service'"
                        :inputName='getSectionName(page.type)'
                        v-bind:sectionData.sync="form.page_sections[i]"
                        :errorMessages="form.$errors"
                        :currIndex="i"
                      />

                      <image-dropper
                        v-if="page.type === 'page_image_dropper'"
                        :inputName='getSectionName(page.type)'
                        v-bind:sectionData.sync="form.page_sections[i]"
                        :errorMessages="form.$errors"
                        :currIndex="i"
                      />

                      <page-spacer
                        v-if="page.type === 'page_spacer'"
                        :inputName='getSectionName(page.type)'
                        v-bind:sectionData.sync="form.page_sections[i]"
                        :errorMessages="form.$errors"
                        :currIndex="i"
                      />
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>

            </draggable>

          </v-col>
          <v-col
            lg="4"
            md="6"
            sm="12"
          >
            <v-card
              outlined
              class="px-6 pb-6 mt-4"
              :class="{ fixed: isFixed }"
            >
              <label class="subtitle-1 d-block pb-3 pt-2 mt-4 grey--text">Available Components</label>
              <v-list dense>
                <v-list-item-group>
                  <draggable
                    class="dragArea list-group"
                    :list="available_components"
                    :group="{ name: 'people', pull: 'clone', put: false }"
                    :clone='cloneComponent'
                  >
                    <v-list-item
                      v-for="(component, i) in available_components"
                      :key="i"
                    >
                      <v-list-item-content>
                        <v-card outlined>

                          <v-card-text>{{ component.name }}</v-card-text>
                        </v-card>
                      </v-list-item-content>
                    </v-list-item>
                  </draggable>
                </v-list-item-group>
              </v-list>
            </v-card>
          </v-col>
        </v-row>
      </v-tab-item>
    </v-tabs-items>

    <v-overlay
      absolute
      :value="updating"
    >
      <v-dialog
        v-model="updating"
        hide-overlay
        persistent
        width="300"
      >
        <v-card
          color="primary"
          dark
        >
          <v-card-text>
            {{ loading_message }}
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-overlay>
    <v-snackbar
      v-model="snackbar.show"
      right
      :color="snackbar.color"
    >
      {{ snackbar.message }}
      <v-btn
        text
        @click="snackbar.show = false"
      >OK</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import Form from '@/utils/form'
import get from 'lodash/get'
import keys from 'lodash/keys'
import head from 'lodash/head'
import replace from 'lodash/replace'
import AppBarNavIcon from '@/layouts/shared/AppBarNavIcon'
import ImageFileInputViewer from '@/components/ImageFileInputViewer'
import PageBuilder from '@/models/PageBuilder'
import dayjs from 'dayjs'
import has from 'lodash/has'
import isNull from 'lodash/isNull'
import draggable from 'vuedraggable'
import SocialSharingMetaTag from '@/components/SocialSharingMetaTag'
import slugify from 'slugify'
import SlugGenerator from '@/components/SlugGenerator'
import HowTo from './components/HowTo'
import Feature from './components/Feature'
import PageButton from './components/PageButton'
import PageBody from './components/PageBody'
import PageHeading from './components/PageHeading'
import PageCards from './components/PageCards'
import PageGallery from './components/PageGallery'
import PageService from './components/PageService'
import ImageAltText from '@/components/ImageAltText'
import PublishStatus from './components/PublishStatus'
import ImageDropper from './components/ImageDropper'
import PageSpacer from './components/PageSpacer'
import ColorPicker from '@/components/ColorPicker'
import FontSelector from '@/components/FontSelector'
import PublishedDateSelector from '@/views/Home/Articles/shared/PublishedDateSelector'
import find from 'lodash/find'
import forEach from 'lodash/forEach'
import { mapActions } from 'vuex'

const initialData = {
  hero_banner: null,
  hero_banner_mobile: null,
  tc: {},
  page_sections: [],
  seo_title: null,
  seo_description: null,
  seo_thumbnail: null,
  publish_status: 'draft',
  title_tag: null,
  path_url: null,
  tnc_txt: null,
  tnc_btn_txt: null,
  tnc_btn_url: null,
  main_btn_color: '#3F51B5',
  tnc_txt_color: '#000000',
  main_font: 'Roboto',
  sub_font: 'Roboto',
  published_at: null,
  dummy_data: new File(['foo'], 'foo.txt', {
    type: 'text/plain'
  }),
  removed_sections: [],
  tnc_txt_weight: null,
  tnc_btn_size: 'blocked',
  desktop_width: null,
  hide_banner: false,
  is_duplicate: false,
  is_noindex: false,
  hide_promotion: true,
  hide_bonus: true,
  hero_banner_url: null
}

export default {

  components: {
    AppBarNavIcon,
    ImageFileInputViewer,
    draggable,
    SocialSharingMetaTag,
    SlugGenerator,
    HowTo,
    Feature,
    PageButton,
    PageBody,
    PageHeading,
    PageCards,
    PageGallery,
    PageService,
    ImageAltText,
    PublishStatus,
    ColorPicker,
    FontSelector,
    PublishedDateSelector,
    ImageDropper,
    PageSpacer

  },

  data () {
    return {
      test: [],
      loading: false,
      updating: false,
      loading_message: 'Loading',
      snackbar: {
        show: false,
        message: null,
        color: 'success'
      },
      loadingTags: false,
      form: new Form({
        ...initialData
      }),
      available_components: [
        {
          section: 'page_how_to',
          name: 'How to'
        },
        {
          section: 'page_gallery',
          name: 'Gallery'
        },
        {
          section: 'page_heading',
          name: 'Heading'
        },
        {
          section: 'page_feature',
          name: 'Feature'
        },
        {
          section: 'page_body',
          name: 'Page Body'
        },
        {
          section: 'page_button',
          name: 'Button'
        },
        {
          section: 'page_card',
          name: 'Cards'
        },
        {
          section: 'page_service',
          name: 'Service'
        },
        {
          section: 'page_image_dropper',
          name: 'Image Dropper'
        },
        {
          section: 'page_spacer',
          name: 'Page Spacer'
        }
      ],
      tabItems: [
        'Page Details',
        'Page Sections'
      ],
      tab: 0,
      currentScrollPosition: 0,
      txtWeightOptions: [
        '300',
        '400',
        '500',
        '600'
      ],
      sectionWErrors: []
    }
  },
  props: {
    pageBuilder: {
      type: [PageBuilder, Object],
      default () {
        return {}
      }
    },
    pageTitle: {
      type: String,
      default: 'Landing Page Builder'
    },
    redirectCancelTo: {
      type: [String, Object],
      default () {
        return {
          name: 'landing-page-builder'
        }
      }
    },
    redirectSaveTo: {
      type: [String, Object],
      default () {
        return {
          name: 'landing-page-builder'
        }
      }
    }
  },

  methods: {
    head,
    replace,
    ...mapActions({
      deleteHeroImage: 'pageBuilder/deleteHeroImage',
      deleteMobileHeroImage: 'pageBuilder/deleteMobileHeroImage'
    }),
    onCancel () {
      this.$router.replace(this.redirectCancelTo)
    },

    async onSave () {
      try {
        this.sectionWErrors = []
        this.form.$busy = true
        this.form.$clearErrors()

        this.cleanFormImages()

        const data = this.form.$data()

        data.path_url = this.slug

        if (has(data, 'published_at') && !isNull(data.published_at)) {
          data.published_at = dayjs(data.published_at).format('YYYY-MM-DD HH:mm:ss')
        }

        if (this.isModeUpdate) {
          this.$delete(data, 'sections')
          data._method = 'put'

          if (this.form.$originalData.hero_banner && !data.hero_banner) {
            await this.deleteHeroImage(data.id)
          }

          if (this.form.$originalData.hero_banner_mobile && !data.hero_banner_mobile) {
            await this.deleteMobileHeroImage(data.id)
          }

          if ((data.hero_banner && data.hero_banner.id) || isNull(data.hero_banner)) { this.$delete(data, 'hero_banner') }
          if ((data.hero_banner_mobile && data.hero_banner_mobile.id) || isNull(data.hero_banner_mobile)) { this.$delete(data, 'hero_banner_mobile') }
          if (data.seo_thumbnail && data.seo_thumbnail.id) { this.$delete(data, 'seo_thumbnail') }
        }

        if (!data.tnc_btn_url) { this.$delete(data, 'tnc_btn_url') }

        const pageBuilder = new PageBuilder(data)
        await pageBuilder.save()

        this.$router.replace(this.redirectSaveTo)
      } catch (error) {
        if (get(error, 'response.status') === 422) {
          if (get(error, 'response.data.errors') !== null) {
            this.form.$setErrors(get(error, 'response.data.errors'))
            let errors = this.form.$errors
            this.pageSectionErrors()

            if (has(errors, 'path_url') || has(errors, 'title_tag') || has(errors, 'tnc_btn_txt') || has(errors, 'tnc_btn_url') || has(errors, 'tnc_txt') || has(errors, 'tnc_txt_weight')) {
              this.tab = 0
            } else {
              this.tab = 1
            }
          } else {
            this.showSnackbar('Something went wrong.', 'error')
          }
        } else {
          this.showSnackbar(error, 'error')
        }
      } finally {
        this.form.$busy = false
      }
    },
    showSnackbar (message, color = 'success') {
      this.snackbar.message = message
      this.snackbar.show = true
      this.snackbar.color = color
    },
    removeSection (i) {
      if (this.form.page_sections[i].id) {
        this.form.removed_sections.push({
          type: 'page_section',
          id: this.form.page_sections[i].id
        })
      }

      this.form.page_sections.splice(i, 1)
    },
    cloneComponent (component) {
      let tempObj = {
        type: component.section,
        name: component.name,
        bg_color: '#FFFFFF'

      }
      const multipleInputComponents = ['page_feature', 'page_how_to', 'page_card', 'page_gallery']
      tempObj[component.section] = {}

      if (multipleInputComponents.includes(component.section)) {
        tempObj[component.section] = []
      }

      if (component.section === 'page_heading' || component.section === 'page_service') {
        tempObj[component.section].props = [
          {
            column_name: 'title',
            color: '#000000',
            style: null
          }
        ]
        tempObj[component.section].bg_color = '#FFFFFF'
      }

      if (component.section === 'page_button') {
        tempObj[component.section].is_blocked = true
        tempObj[component.section].is_xsmall = false
        tempObj[component.section].is_small = false
        tempObj[component.section].is_medium = false
        tempObj[component.section].is_large = false
        tempObj[component.section].is_xlarge = false
      }

      return tempObj
    },
    onScroll () {
      this.currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop
    },
    getSectionName (section) {
      let sectionData = find(this.available_components, ['section', section])
      return sectionData.name
    },

    cleanFormImages () {
      const multipleInputComponents = ['page_feature', 'page_how_to', 'page_card', 'page_gallery']
      forEach(this.form.page_sections, (value, i) => {
        if (value[value.type]) {
          let sectionData = value[value.type]

          if (multipleInputComponents.includes(value.type)) {
            forEach(sectionData, (v, index) => {
              if ((v.thumbnail && v.thumbnail.id) || isNull(v.thumbnail)) { this.$delete(this.form.page_sections[i][value.type][index], 'thumbnail') }
              if ((v.thumbnail_mobile && v.thumbnail_mobile.id) || isNull(v.thumbnail_mobile)) { this.$delete(this.form.page_sections[i][value.type][index], 'thumbnail_mobile') }
            })
          }

          if (value.type === 'page_service' || value.type === 'page_image_dropper') {
            if ((value[value.type].thumbnail && value[value.type].thumbnail.id) || isNull(value[value.type].thumbnail)) { this.$delete(this.form.page_sections[i][value.type], 'thumbnail') }
            if ((value[value.type].thumbnail_mobile && value[value.type].thumbnail_mobile.id) || isNull(value[value.type].thumbnail_mobile)) { this.$delete(this.form.page_sections[i][value.type], 'thumbnail_mobile') }
          }
        }

        if ((value.bg_thumbnail && value.bg_thumbnail.id) || isNull(value.bg_thumbnail)) { this.$delete(this.form.page_sections[i], 'bg_thumbnail') }
      })
    },

    marginTop (index) {
      return index !== 0
    },

    titleError (errorString) {
      if (errorString) {
        return 'Header Text is required'
      } else {
        return null
      }
    },

    pageSectionErrors () {
      let errors = this.form.$errors

      let sectionErrors = keys(errors)

      forEach(sectionErrors, (value) => {
        let errorIndex = value.split('.')

        if (errorIndex[0] === 'page_sections') { this.sectionWErrors.push(errorIndex[1]) }
      })
    },

    checkSectionError (index) {
      return this.sectionWErrors.includes(String(index))
    }

  },

  watch: {
    pageBuilder: {
      immediate: true,
      handler (val) {
        if (val) {
          this.form = new Form({
            ...initialData,
            ...val
          })

          if (val.sections) {
            this.form.page_sections = val.sections
          }

          if (!this.form.path_url) {
            this.$nextTick(() => this.$refs['slugGenerator'].generate())
          }
        }
      }
    }
  },

  computed: {
    isModeUpdate () {
      return get(this.form, 'id', null) !== null
    },
    slug: {
      get () {
        if (this.form.path_url && this.form.path_url.trim() !== '') {
          return this.form.path_url
        }

        if (this.form.title_tag) {
          return '/' + slugify(this.form.title_tag, {
            remove: /[*+~.()'"!:@]/g,
            lower: true,
            strict: true
          })
        }

        return ''
      },
      set (v) {
        this.form.path_url = v
      }
    },
    isFixed () {
      if (this.tab === 1 && this.currentScrollPosition >= 200) {
        return true
      }
      return false
    },
    showPublishDateSelector () {
      let show = false

      if (this.form.publish_status === 'published') {
        show = true
      }

      return show
    }
  },

  mounted () {
    // window.addEventListener('scroll', this.onScroll)
    this.form.removed_sections = []
  }
}
</script>

<style Scoped>
.page-content-col {
  overflow-y: scroll;
  max-height: 1000px;
}
.page-content-draggable-container {
  min-height: 500px;
}
.fixed {
  position: fixed;
  width: 100%;
  max-width: 22.8%;
  top: 0;
}
.header-btns {
  color: #df4661;
  cursor: pointer;
}

.section-has-error {
  border-color: var(--v-error-base) !important;
  border-width: 2px;
  border-style: solid;
}
</style>
